// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5688d55","667":"484d34f8"}[chunkId] + ".chunk.js";
};